import { ISummaryTableDataNode } from 'components/common/SummaryTable/SummaryTable.properties';

const schema: ISummaryTableDataNode[] = [
    {
        objectName: 'ProductReceiptSummary',
        isLoading: 'productReceiptLoading',
        title: 'Receipt details',
        children: [
            {
                label: 'Warehouse',
                fieldNames: [
                    'Warehouse',
                    'WarehouseLabel'
                ],
            },
            {
                label: 'Supplier',
                fieldNames: [
                    'SupplierIdDisplay',
                    'SupplierIdDisplayLabel',
                    'SupplierCityState'
                ],
                valueRenderer: {
                    disableMenu: true,
                    api: {
                        api: '/supplierEnquiry/lookup/action',
                        name: 'supplier',
                        params: {
                            queryFields: {
                                SupplierId: 'SupplierId',
                                SearchText: 'SupplierId'
                            }
                        }
                    }
                }
            },
            {
                label: 'Reference',
                fieldNames: [
                    'Reference',
                ],
            },
            {
                label: 'Invoice',
                fieldNames: [
                    'Invoice',
                ],
            },
            {
                label: 'Date',
                fieldNames: [
                    'Date'
                ],
            }

        ]
    },
    {
        objectName: 'ProductReceiptSummary',
        isLoading: 'productReceiptLoading',
        title: 'Totals',
        children: [
            {
                label: 'Currency',
                fieldNames: [
                    'Currency',
                ],
            },
            {
                label: 'Freight (EX. Tax)',
                fieldNames: [
                    'FreightDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 2
                }
            },
            {
                label: 'Tax Total',
                fieldNames: [
                    'TaxTotalDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 2
                }
            },
            {
                label: 'Overcharge Total',
                fieldNames: [
                    'OverchargeTotalDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    floatingPoints: 2
                }
            },
            {
                label: 'Receipt Total',
                fieldNames: [
                    'ReceiptTotalDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    emphasize: true,
                    floatingPoints: 2
                }
            },
        ]
    },
    {
        objectName: 'ProductReceiptSummary',
        isLoading: 'productReceiptLoading',
        title: '',
        children: [
            {
                label: 'Invoice Total',
                fieldNames: [
                    'InvoiceTotalDisplay',
                ],
                valueRenderer: {
                    isNumericDisplay: true,
                    emphasize: true,
                    floatingPoints: 2
                }
            }
        ]
    },
];

export default schema;
